export const firebaseConfig = {
	apiKey : "AIzaSyByC_kVv6Ll5Rg6VzR76WQ_tmxut1_wDIU",
	authDomain : "carmel-alllowances-app.firebaseapp.com",
	databaseURL : "https://carmel-alllowances-app.firebaseio.com",
	projectId : "carmel-alllowances-app",
	storageBucket : "carmel-alllowances-app.appspot.com",
	messagingSenderId : "515855105004"
};




// WEBPACK FOOTER //
// ./src/data/config.js